/** @format */

export const MasterCardSmall = () => {
    return (
        <svg width="23" height="16" viewBox="0 0 23 16" fill="none">
            <rect x="0.5" y="0.5" width="22" height="15" rx="2" fill="white" stroke="#D9D9D9" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7144 11.6974C10.8368 12.4337 9.69841 12.8782 8.45446 12.8782C5.67881 12.8782 3.42871 10.6652 3.42871 7.93534C3.42871 5.20547 5.67881 2.99248 8.45446 2.99248C9.69841 2.99248 10.8368 3.43697 11.7144 4.17328C12.592 3.43698 13.7304 2.99249 14.9744 2.99249C17.75 2.99249 20.0001 5.20549 20.0001 7.93536C20.0001 10.6652 17.75 12.8782 14.9744 12.8782C13.7304 12.8782 12.592 12.4337 11.7144 11.6974Z"
                fill="#ED0006"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7144 11.6974C12.795 10.7908 13.4802 9.44178 13.4802 7.93534C13.4802 6.42891 12.795 5.07987 11.7144 4.17326C12.592 3.43696 13.7303 2.99248 14.9743 2.99248C17.7499 2.99248 20 5.20547 20 7.93534C20 10.6652 17.7499 12.8782 14.9743 12.8782C13.7303 12.8782 12.592 12.4337 11.7144 11.6974Z"
                fill="#F9A000"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7145 11.6974C12.7951 10.7908 13.4803 9.4418 13.4803 7.93538C13.4803 6.42896 12.7951 5.07994 11.7145 4.17332C10.6339 5.07994 9.94873 6.42896 9.94873 7.93538C9.94873 9.4418 10.6339 10.7908 11.7145 11.6974Z"
                fill="#FF5E00"
            />
        </svg>
    );
};
